import { render, staticRenderFns } from "./DeletePartner.vue?vue&type=template&id=34327012&scoped=true&"
import script from "./DeletePartner.vue?vue&type=script&lang=js&"
export * from "./DeletePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34327012",
  null
  
)

export default component.exports